import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e26fffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("cluster 向け"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("画像ファイルをアップロードするだけで"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Url Texture,Url Raw Image 用 URLを生成するツール")
  ])
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "formcontainer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "識別するためのユニークな文字列(英数字半角)", -1))
const _hoisted_6 = { class: "fileform" }
const _hoisted_7 = { class: "file" }
const _hoisted_8 = { class: "file-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-cta" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "file-label" }, "ファイル選択")
], -1))
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "formcontainer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Url Texture,Url Raw Image に設定するURL", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "image" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            class: "input key",
            type: "text",
            placeholder: "識別するためのユニークな文字列(英数字半角)",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.key) = $event))
          }, null, 512), [
            [_vModelText, _ctx.key]
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("input", {
                class: "file-input",
                type: "file",
                name: "resume",
                ref: "file",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                accept: "image/*"
              }, null, 544),
              _hoisted_9
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("input", {
          class: "input fileUrl",
          type: "text",
          placeholder: "Url Textureに設定するURL",
          value: _ctx.fileUrl
        }, null, 8, _hoisted_13)
      ]),
      _createElementVNode("figure", _hoisted_14, [
        (_ctx.fileUrl == '')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require('../assets/logo.png'),
              alt: "128x128"
            }, null, 8, _hoisted_15))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.fileDataUrl,
              alt: "128x128"
            }, null, 8, _hoisted_16))
      ])
    ])
  ]))
}